import { connectFunctionsEmulator, getFunctions, httpsCallable } from 'firebase/functions';
import { app, usingEmulators } from './app';

export const functions = getFunctions(app, 'europe-west1');
if (usingEmulators) connectFunctionsEmulator(functions, '127.0.0.1', 5001);

/** Crida tipada a una Function callable. */
export async function call<In, Out>(name: string, data: In): Promise<Out> {
  const res = await httpsCallable<In, Out>(functions, name)(data);
  return res.data;
}
